import { render, staticRenderFns } from "./LoginNavbarItem.vue?vue&type=template&id=12cd61b4&scoped=true&"
import script from "./LoginNavbarItem.vue?vue&type=script&lang=js&"
export * from "./LoginNavbarItem.vue?vue&type=script&lang=js&"
import style0 from "./LoginNavbarItem.vue?vue&type=style&index=0&id=12cd61b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cd61b4",
  null
  
)

export default component.exports